import React from 'react'
import { useTranslation } from 'react-i18next'
import { CalendarClock, X } from 'lucide-react'
import { AppLink } from '@/components/ui/app-link'
import { formatScheduleDate, onScheduled, scheduledPath, type ScheduledAnnouncement } from './postSchedule'

/**
 * F-164: after a post is scheduled, "Agendado para 3 de nov., 10:00", with
 * the way to "Agendados" (the post is not in the feed until then). Mounted
 * once in the shell, like the e-mail notice toaster.
 */
export function ScheduledToaster() {
  const { t, i18n } = useTranslation('common')
  const [toast, setToast] = React.useState<(ScheduledAnnouncement & { id: number }) | null>(null)
  React.useEffect(() => onScheduled((a) => {
    const id = Date.now()
    setToast({ ...a, id })
    window.setTimeout(() => setToast((current) => (current?.id === id ? null : current)), 9000)
  }), [])
  if (!toast) return null
  return (
    <div className="pointer-events-none fixed inset-x-4 bottom-4 z-[60] flex justify-center sm:inset-x-auto sm:right-4" aria-live="polite">
      <div role="status" className="pointer-events-auto flex w-full max-w-sm items-start gap-3 rounded-xl border border-border bg-surface/95 p-4 text-foreground shadow-lg backdrop-blur-sm" data-testid="scheduled-toast">
        <CalendarClock className="mt-0.5 h-4 w-4 flex-shrink-0 text-primary" aria-hidden />
        <div className="min-w-0 flex-1 text-sm">
          <p>{t('postSchedule.toast', { date: formatScheduleDate(toast.publishAt, i18n.language) })}</p>
          <AppLink to={scheduledPath(toast.spaceId)} onClick={() => setToast(null)} className="mt-1 inline-block font-medium text-primary hover:underline">{t('postSchedule.seeScheduled')}</AppLink>
        </div>
        <button type="button" aria-label={t('postSchedule.dismiss')} className="flex-shrink-0 text-muted-foreground hover:text-foreground-secondary" onClick={() => setToast(null)}><X className="h-4 w-4" /></button>
      </div>
    </div>
  )
}
